<script>
    import { push } from 'svelte-spa-router'
    import { user, gotCode } from '../../store'
    import CognitoAuth from '../../cognito/index.js'

    let error = ''
    let show = false

    const cancel = _ => {
        $gotCode = false
        push('/login')
    }

    const sendCode = _ => {
        const cognito = new CognitoAuth()

        cognito.sendVerificationCode()
            .then(result => ($gotCode = true, error = ''))
            .catch(err => error = err.message)
    }

    const next = _ => {
        const cognito = new CognitoAuth()

        cognito.confirmRecovery()
            .then(result => ($gotCode = false, error = '', push('/')))
            .catch(err => error = err.message)
    }

    const toggle = _ => {
        show = ! show
        document.getElementById('newPassword').type = show ? 'text' : 'password'
    }

</script>

<main>
    <div class="min-h-screen flex items-center flex-col bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col space-y-8 mt-12 w-full max-w-md">
            <div class="font-medium self-center text-xl sm:text-2xl uppercase text-gray-800">Password recovery</div>
            <div class="relative mt-10 h-px bg-gray-300">
                <div class="relative left-0 top-0 flex justify-center w-full ">
                    <span class=" px-4 text-base text-red-500 uppercase">
                        { error }
                    </span>
                </div>
            </div>
            {#if $gotCode}
                <div class="mt-10">
                    <form id="passwordResetForm">
                        <div class="flex flex-col mb-6">
                            <label for="verifyCode" class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600">Verification code:</label>
                            <div class="relative">
                                <input bind:value={$user.verifyCode} id="verifyCode" type="text" name="Verification code" class="text-sm sm:text-base placeholder-stone-500 pl-3 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-yellow-400" placeholder="Verification code" />
                            </div>
                        </div>
                        <div class="flex flex-col mb-6">
                            <label for="newPassword" class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600">Password:</label>
                            <div class="relative flex flex-row">
                                <div class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                                    <svg class="h-6 w-6" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                </div>

                                <input bind:value={$user.newPassword} id="newPassword" type="password" name="newPassword" class="text-sm sm:text-base placeholder-stone-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-yellow-400" placeholder="New password" />

                                {#if show}
                                    <div class="inline-flex items-center justify-center absolute right-0 top-0 h-full w-10 text-gray-400">
                                        <svg on:click={toggle} xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                        </svg>
                                    </div>
                                {:else}
                                    <div class="inline-flex items-center justify-center absolute right-0 top-0 h-full w-10 text-gray-400">
                                        <svg on:click={toggle} xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                {/if}
                            </div>
                        </div>

                    </form>
                    <div class="flex w-full ">
                        <div class="flex w-full mr-2"> <!--disabled if no username-->
                            <button  on:click|preventDefault={ next } class="flex items-center justify-center focus:outline-none text-black text-sm sm:text-base bg-green-300 hover:bg-green-500 rounded py-2 w-full transition duration-150 ease-in">
                                <span class="mr-2 uppercase font-semibold text-black">Next</span>
                                <span>
                            <svg class="h-6 w-6" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                                <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </span>
                            </button>
                        </div>
                        <div class="flex w-full">
                            <button  on:click={ cancel } class="flex items-center justify-center focus:outline-none text-black text-sm sm:text-base bg-red-300 hover:bg-red-500  rounded py-2 w-full transition duration-150 ease-in">
                                <span class="mr-2 uppercase font-semibold text-black">Cancel</span>
                                <span>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </span>
                            </button>
                        </div>
                    </div>
                </div>
            {:else}
                <div class="mt-10">
                    <form class="mt-8 space-y-6 ">
                        <div class="rounded-md">
                            <div class="py-4" >
                                <label for="username" class="sr-only">Username:</label>
                                <div class="relative">
                                    <div class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>

                                    <input bind:value={$user.username} id="username" name="username" type="text" required class="rounded-md w-full  border border-gray-500 placeholder-stone-500 text-stone-900 pl-10 py-2 focus:outline-none focus:border-indigo-500" placeholder="e-mail">
                                </div>
                            </div>
                        </div>
                        <div class="flex w-full ">
                            <div class="flex w-full mr-2">
                                <button  on:click|preventDefault={ sendCode } disabled={! $user.username} class="flex items-center bg-green-300 hover:bg-green-500 justify-center focus:outline-none text-sm sm:text-base bg- rounded py-2 w-full transition duration-150 ease-in">
                                    <span class="mr-2 uppercase font-semibold text-black">Next</span>
                                    <span>
                                            <svg class="h-6 w-6" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="black">
                                                <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </span>
                                </button>
                            </div>
                            <div class="flex w-full">
                                <button  on:click|preventDefault={ cancel } class="flex items-center justify-center focus:outline-none text-sm sm:text-base rounded py-2 w-full bg-red-300 hover:bg-red-500 transition duration-150 ease-in">
                                    <span class="mr-2 uppercase font-semibold text-black">Cancel</span>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="black">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            {/if}
        </div>
        <p>
    </div>
</main>
